import React from "react";
import "./style.css";
import { FaSearch, FaWhatsapp, FaBox } from "react-icons/fa";

const HTBSection = () => {
  return (
    <section className="como-comprar-section">
      <h2 className="como-comprar-title">Como comprar</h2>
      <p className="como-comprar-subtitle">
        Em poucos passos, você fala com um especialista e recebe sua peça onde
        estiver.
      </p>

      <div className="passos-container">
        <div className="passo">
          <FaSearch className="passo-icon" />
          <h3>1. Busque a peça</h3>
          <p>Identifique o nome, código ou modelo da peça que você precisa.</p>
        </div>

        <div className="passo">
          <FaWhatsapp className="passo-icon" />
          <h3>2. Fale com um especialista</h3>
          <p>
            Envie sua dúvida no WhatsApp e receba atendimento técnico em tempo
            real.
          </p>
        </div>

        <div className="passo">
          <FaBox className="passo-icon" />
          <h3>3. Receba sua peça</h3>
          <p>
            Conclua o pedido pelo WhatsApp e receba a peça com rapidez e
            segurança.
          </p>
        </div>
      </div>
    </section>
  );
};

export default HTBSection;
